// utils/getTailwindColor.js
export function getTailwindColor(variableName) {
  return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim();
}

export function downloadCSV(data: BlobPart, filename: string = "download.csv", mimeType: string = "application/vnd.ms-excel"): void {
  const blob = new Blob([data], { type: mimeType });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

export function downloadFile(data, filename) {
  const blob = new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}

export function formatPrice(price: number | string): string {
  const num = Number(price ?? 0);
  if (Number.isNaN(num)) return "0.0";
  if (num === 0) return "0.0";

  const fixed1 = num.toFixed(1);
  if (fixed1 !== "0.0") return fixed1;

  let decimals = 2;
  while (decimals < 10) {
    const fixed = num.toFixed(decimals);
    if (parseFloat(fixed) > 0) {
      return fixed;
    }
    decimals++;
  }
  return fixed1;
}